"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import { WifiX } from "@phosphor-icons/react/dist/ssr";

import { Button } from "@ndpco/ui/components/Button";

const PushNotificationDialog = dynamic(() => import("@/components/push-notification-dialog"), {
  ssr: false,
});

const RegisterPwa = () => {
  const [updateAvailable, setUpdateAvailable] = useState<boolean>(false);
  const [isOffline, setIsOffline] = useState<boolean>(false);

  const updateOnlineStatus = () => {
    if (!navigator.onLine) {
      setIsOffline(true);
    } else {
      setIsOffline(false);
    }
  };

  useEffect(() => {
    if ("serviceWorker" in navigator && window.serwist !== undefined) {
      window.serwist
        .register()
        .then((registration) => {
          if (registration == null) return;
          registration.onupdatefound = () => {
            const installingWorker = registration?.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  setUpdateAvailable(true);
                  console.log("🚀 New content is available; please refresh.");
                } else {
                  console.log("Content is cached for offline use.");
                }
              }
            };
          };
        })
        .catch((err) => console.error("[SW ERROR]", err));
    }

    // Add event listeners for online and offline events
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  return (
    <>
      {/*{<PushNotificationDialog />}*/}
      {isOffline && (
        <div className="fixed inset-x-0 top-0 z-50 m-auto w-full max-w-sm pt-[env(safe-area-inset-top)]">
          <div className="m-4 flex items-center gap-1 rounded-lg bg-red-600/80 p-3 pl-1.5 text-sm text-white shadow-xl backdrop-blur-md">
            <WifiX className="size-5" />
            <p>اتصال اینترنت خود را بررسی کنید!</p>
          </div>
        </div>
      )}
      {updateAvailable && (
        <div className="fixed inset-x-0 top-0 z-50 m-auto w-full max-w-sm pt-[env(safe-area-inset-top)]">
          <div className="m-4 flex items-center justify-between rounded-lg border border-zinc-200 bg-white/90 p-3 pl-1.5 shadow-xl backdrop-blur-md">
            <p className="text-sm text-zinc-950">🚀 نسخه جدید اپلیکیشن آماده است!</p>
            <Button variant="subtle" size="xs" onClick={() => window.location.reload()}>
              به‌روزرسانی
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default RegisterPwa;
